import { render, staticRenderFns } from "./ContentBox.html?vue&type=template&id=612203b6&"
import script from "./ContentBox.js?vue&type=script&lang=js&"
export * from "./ContentBox.js?vue&type=script&lang=js&"
import style0 from "./ContentBox.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports